import { makeStyles } from 'tss-react/mui';

export const useProductMediaEmptyStateStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: theme.shape.borderRadius,
  },
}));
